/**
 * Mira API Management Service
 * Our API uses a REST based design, leverages the JSON data format, and relies upon HTTPS for transport. We respond with meaningful HTTP response codes and if an error occurs, we include error details in the response body. API Documentation is at sweyainfotech.com/contact
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MiraManagementApiDomainAssetsDtosAssetDto { 
    id?: string;
    name?: string | null;
    alliesId?: number;
    category?: string | null;
    tagId?: string | null;
    tagName?: string | null;
    tagAlliesId?: string | null;
    currentLocation?: string | null;
    previousLocation?: string | null;
    isAssetInside?: boolean;
    assetTrackingStatus?: string | null;
    status?: string | null;
    lastTrackedOn?: string | null;
    plantCode?: string | null;
    manufacturer?: string | null;
    model?: string | null;
    serialNumber?: string | null;
    barcode?: string | null;
}

